<ng-container *transloco="let convert;">
  <div [ngClass]="tenantClass$ | async" #accordionWrapper>
    <h2 data-test-id="alerts-page-heading" tabindex="-1" class="focus-outline-none" id="alerts-header">
    {{convert('profileManagement.userContact.textMyAlert')}}</h2>
    <p data-test-id="alerts-page-description">{{convert('profileManagement.userContact.textSelectAlert')}}</p>
    <accordion class="pb-0 alert-settings">
      @if (buyAlerts$) {
        <accordion-group data-test-id="alerts-buy-accordion" panelClass="buy-accordion" class="child-accordion" [isOpen]="buyIsOpen"
          (isOpenChange)="isOpenChange($event, 'buy')" #buyAccordion>
          <div data-test-id="alerts-buy-accordion-toggle" tabindex="0" class="btn btn-link btn-block clearfix alert-settings__toggle" accordion-heading
            (click)="toggleBuyAccordion()" (keydown.enter)="toggleBuyAccordion()" data-track-elem="accordion"
            data-track-name="Buy"
            data-track-trigger="statechange" [attr.data-track-state]="buyIsOpen ? 'opened' : 'closed'"
            [attr.aria-label]="buyIsOpen ? convert('profileManagement.userContact.ariaLabelBuyExpanded') : convert('profileManagement.userContact.ariaLabelBuyCollapsed')">
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i> <span
          class="d-inline-block ms-1">{{convert('profileManagement.userContact.textBuy')}}</span>
        </div>
        @if (showBuyError) {
          <error-message data-test-id="alerts-buy-error-message" id="buy-error-message" tabindex="-1"></error-message>
        }
        @if (showBuySuccess) {
          <success-message data-test-id="alerts-buy-success-message" message="{{convert('profileManagement.userContact.textSuccessfullyBuyAlert')}}"
          id="buy-success-message" tabindex="-1"></success-message>
        }
        @if (requireMobileConsent) {
          <p data-test-id="alerts-buy-mobile-consent-message"> {{convert('notifications.editMobile1')}}
            <a data-test-id="alerts-buy-mobile-consent-link" class="profile-nav__link"
              href="javascript:void(0);" (click)="navigateTo('/profile-management/contact-information')"
              [ngClass]="activeChildRoute == '/profile-management/contact-information' ? activeClass : null">
            {{convert('notifications.mobileNumber')}}</a>
            {{convert('notifications.editMobile2')}}
          </p>
        }
        @if (buyIsOpen) {
          <table data-test-id="alerts-buy-table" class="alert-settings__table" id="buy_table" tabIndex="-1">
            <caption class="d-none">
              {{convert('profileManagement.userContact.textBuyAlerts')}}
            </caption>
            <colgroup>
            <col class="alert-settings__setting-value" />
            <col />
          </colgroup>
          @if (buyAlerts$ | async; as buyAlerts) {
            @if (hasAlertType(buyAlerts, 'Text')) {
              <thead>
                <tr>
                  <th scope="col">{{convert('profileManagement.userContact.text')}}</th>
                  <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                </tr>
              </thead>
            }
            <tbody>
              @for (alert of buyAlerts; track alert; let i = $index) {
                <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                  [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                  @if (alert.sendType === 'Text') {
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-buy-text-checkbox-' + i"
                          (change)="updateNotificationBuy($event, alert)" [checked]="checked(alert.type)"
                          attr.aria-label="{{ convert('notifications.'+alert.type) }}" [attr.aria-hidden]="!buyIsOpen"
                          [disabled]="requireMobileConsent" />
                        <label [for]="alert.type" class="custom-control-label"
                          [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                        </label>
                      </div>
                    </td>
                    <td class="alert-settings__options">{{ convert("notifications." + alert.type) }}</td>
                  }
                </tr>
              }
            </tbody>
          }
          @if (buyAlerts$ | async; as buyAlerts) {
            @if (hasAlertType(buyAlerts, 'Email')) {
              <thead>
                <tr>
                  <th scope="col">{{convert('profileManagement.userContact.labelEmail')}}</th>
                  <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                </tr>
              </thead>
            }
            <tbody>
              @for (alert of buyAlerts; track alert; let i = $index) {
                <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                  [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                  @if (alert.sendType === 'Email') {
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-buy-email-checkbox-' + i"
                          (change)="updateNotificationBuy($event, alert)" [checked]="checked(alert.type)"
                          attr.aria-label="{{ convert('notifications.'+alert.type) }}"
                          [attr.aria-hidden]="!buyIsOpen" />
                        <label [for]="alert.type" class="custom-control-label"
                          [attr.aria-hidden]="!buyIsOpen && !checkVisibility(alert)">
                        </label>
                      </div>
                    </td>
                    <td class="alert-settings__options">{{ convert("notifications." + alert.type) }}</td>
                  }
                </tr>
              }
            </tbody>
          }
        </table>
      }
      @if (buyIsOpen) {
        <div class="d-flex flex-column flex-md-row alert-settings__actions">
          <button data-test-id="alerts-buy-save-button" data-track-elem="button" data-track-name="Save" class="btn btn-primary me-md-2 mb-2 mb-md-0"
            type="button" (click)="saveBuyNotifs()" [attr.aria-hidden]="!buyIsOpen">
            {{convert('common.btnSave')}}
          </button>
          <button data-test-id="alerts-buy-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons" type="button"
            (click)="cancelBuy()" [attr.aria-hidden]="!buyIsOpen">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      }
    </accordion-group>
  }

  @if (showSellerAlerts) {
    @if (sellAlerts$) {
      <accordion-group data-test-id="alerts-sell-accordion" panelClass="sell-accordion" class="child-accordion" [isOpen]="sellIsOpen"
        (isOpenChange)="isOpenChange($event, 'sell')" #sellAccordion>
        <div data-test-id="alerts-sell-accordion-toggle" tabindex="0" class="btn btn-link btn-block clearfix alert-settings__toggle" accordion-heading
          (click)="toggleSellAccordion()" (keydown.enter)="toggleSellAccordion()" data-track-elem="accordion"
          data-track-name="Sell"
          data-track-trigger="statechange" [attr.data-track-state]="sellIsOpen ? 'opened' : 'closed'"
          [attr.aria-label]="sellIsOpen ? convert('profileManagement.userContact.ariaLabelSellExpanded') : convert('profileManagement.userContact.ariaLabelSellCollapsed')">
          <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
          <span class="d-inline-block ms-1">{{convert('profileManagement.userContact.textSell')}}</span>
        </div>
        @if (showSellError) {
          <error-message data-test-id="alerts-sell-error-message" id="sell-error-message" tabindex="-1"></error-message>
        }
        @if (showSellSuccess) {
          <success-message data-test-id="alerts-sell-success-message" message="{{convert('profileManagement.userContact.textSuccessfullySellAlert')}}"
          id="sell-success-message" tabindex="-1"></success-message>
        }
        <p data-test-id="alerts-sell-description">{{convert('profileManagement.profileMobile.leadSellerNotifications')}}</p>
        @if (requireMobileConsent) {
          <p data-test-id="alerts-sell-mobile-consent-message"> {{convert('notifications.editMobile1')}}
            <a data-test-id="alerts-sell-mobile-consent-link" class="profile-nav__link"
              href="javascript:void(0);" (click)="navigateTo('/profile-management/contact-information')"
              [ngClass]="activeChildRoute == '/profile-management/contact-information' ? activeClass : null">
            {{convert('notifications.mobileNumber')}}</a>
            {{convert('notifications.editMobile2')}}
          </p>
        }
        @if (sellIsOpen) {
          <table data-test-id="alerts-sell-table" class="alert-settings__table" id="sell_table" tabIndex="-1" [attr.aria-hidden]="!sellIsOpen"
            >
            <caption class="d-none">
              {{convert('profileManagement.userContact.textSellAlerts')}}
            </caption>
            <colgroup>
            <col class="alert-settings__setting-value" />
            <col />
          </colgroup>
          @if (sellAlerts$ | async; as sellAlerts) {
            @if (hasAlertType(sellAlerts, 'Text')) {
              <thead>
                <tr>
                  <th scope="col">{{convert('profileManagement.userContact.text')}}</th>
                  <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                </tr>
              </thead>
            }
            <tbody>
              @for (alert of sellAlerts; track alert; let i = $index) {
                <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                  @if (alert.sendType === 'Text') {
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-sell-text-checkbox-' + i"
                          (change)="updateNotificationSell($event, alert)" [checked]="checked(alert.type)"
                          attr.aria-label="{{ convert('notifications.'+alert.type) }}"
                          [attr.aria-hidden]="!sellIsOpen"
                          [disabled]="requireMobileConsent" />
                        <label [for]="alert.type" class="custom-control-label"> </label>
                      </div>
                    </td>
                    <td class="alert-settings__options">{{ convert("notifications." + alert.type) }}</td>
                  }
                </tr>
              }
            </tbody>
          }
          @if (sellAlerts$ | async; as sellAlerts) {
            @if (hasAlertType(sellAlerts, 'Email')) {
              <thead>
                <tr>
                  <th scope="col">{{convert('profileManagement.userContact.labelEmail')}}</th>
                  <th class="alerts-label" scope="col">{{convert('profileManagement.userContact.textSendAlert')}}</th>
                </tr>
              </thead>
            }
            <tbody>
              @for (alert of sellAlerts; track alert; let i = $index) {
                <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                  @if (alert.sendType === 'Email') {
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-sell-email-checkbox-' + i"
                          (change)="updateNotificationSell($event, alert)" [checked]="checked(alert.type)"
                          attr.aria-label="{{ convert('notifications.'+alert.type) }}"
                          [attr.aria-hidden]="!sellIsOpen" />
                        <label [for]="alert.type" class="custom-control-label"> </label>
                      </div>
                    </td>
                    <td class="alert-settings__options">{{ convert("notifications." + alert.type) }}</td>
                  }
                </tr>
              }
            </tbody>
          }
        </table>
      }
      @if (sellIsOpen) {
        <div class="d-flex flex-column flex-md-row alert-settings__actions">
          <button data-test-id="alerts-sell-save-button" data-track-elem="button" data-track-name="Save" class="btn btn-primary me-md-2 mb-2 mb-md-0"
            type="button" (click)="saveSellNotifs()" [attr.aria-hidden]="!sellIsOpen">
            {{convert('common.btnSave')}}
          </button>
          <button data-test-id="alerts-sell-cancel-button" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons" type="button"
            (click)="cancelSell()" [attr.aria-hidden]="!sellIsOpen">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      }
    </accordion-group>
  }
}
</accordion>
<app-save-changes-modal data-test-id="alerts-save-changes-modal" (cancelEditing)="cancelEditing()" (continueEditing)="continueEditing()" [modalId]="modalId">
</app-save-changes-modal>
</div>
</ng-container>
